import React, { createContext, useState } from 'react';
import { accessTokenIsAdmin } from '../utils/adminAuth';
import { clearAuthTokens, getAccessToken } from '../utils/apiClient';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('user');
        if (!storedUser) return null;
        try {
            const parsed = JSON.parse(storedUser);
            if (accessTokenIsAdmin(getAccessToken())) {
                parsed.isAdmin = true;
            }
            return parsed;
        } catch (error) {
            console.error('Invalid stored user session:', error);
            localStorage.removeItem('user');
            return null;
        }
    });

    const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('lastActivity');
        clearAuthTokens();
    };

    return (
        <UserContext.Provider value={{ user, setUser, logout }}>
            {children}
        </UserContext.Provider>
    );
};
